import { IChartThemeColorShower } from '@tencent/chart-drawer-components/lib/interface';
import { Feature } from '@tencent/workbench';
import { SLIDE_ADAPTER } from '@src/framework/workbench/ssr/slide-adapter';
import { ThemeColorSelectorOption } from '@tencent/chart-drawer-components/lib/controllers/global-settings/chart-theme-color/config';
import ChartBaseDrawerFeature from '@src/framework/workbench/drawer/ui/chart/chart-base-drawer-feature';
import { presetColorPalettes } from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-presets/colors';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { getThemeColorValueByIndex } from '@src/slide/domain/ui-model/element-modeles/property/chart/theme';
import { ICTColorDmlA, IEGColorTransform, ISlideDataModel, STSchemeColorVal } from '@tencent/slide-sdk-model';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import isNil from 'lodash/isNil';

@Feature({
    name: 'ChartThemeColorShower',
    adapters: [SLIDE_ADAPTER],
    provide: IChartThemeColorShower,
})
export class ChartThemeColorShower extends ChartBaseDrawerFeature implements IChartThemeColorShower {
    /**
     * 获取当前所选主题色
     */
    public getThemeColor() {
        const model = this.getSelectModel();
        return model.chartSpace?.colorStyle?.id;
    }

    public generateThemeColorOptionValue(option: ThemeColorSelectorOption) {
        if (option === 'divider') {
            return '';
        }
        return String(option.id);
    }

    public getColorSelectorOptions(): ThemeColorSelectorOption[] {
        const options = [
            ...this.genColorSelectorOptions(presetColorPalettes.colorful, 'colorful'),
            'divider',
            ...this.genColorSelectorOptions(presetColorPalettes.monochromatic, 'monochromatic'),
        ];
        return options;
    }


    private genColorSelectorOptions(colorPalettes, type) {
        const colorCount = 6;
        return colorPalettes.map((colorPalette) => {
            const colors = new Array(colorCount).fill(undefined)
                .map((_, index) => {
                    const color = getThemeColorValueByIndex(index, colorPalette.id, colorCount);
                    return this.getColorWithPage(color!);
                });
            return {
                id: colorPalette.id,
                key: colorPalette.id,
                type,
                color: colors,
            };
        });
    }

    private getColorWithPage(tdColor: TDColor) {
        const egColorTransformKeys = ['lumMod', 'lumOff', 'tint', 'shade'];
        const egColorTransform = egColorTransformKeys.map((key) => {
            if (!isNil(tdColor[key])) {
                return {
                    [key]: {
                        val: tdColor[key],
                    },
                };
            }
        }).filter(i => !!i) as IEGColorTransform[];
        const props: ICTColorDmlA = {
            schemeClr: {
                val: tdColor.colorValue as STSchemeColorVal,
                egColorTransform,
            },
        };
        const slideModel = this.getAppService().viewableServiceLayer.selectionService.currentSlide;
        const color =  SlideDataServices.SDKDataServices.ColorManager()?.resolveColor(
            props,
            slideModel?.sdkData as ISlideDataModel,
        )?.srgbClr?.val;
        return color ? `#${color}` : '';
    }
}
